import React, { ComponentProps } from 'react'
import { ArticleRoot, ArticleContainer } from './Article.styles'

type BackgroundVariant = 'tertiary' | 'secondary' | 'white' | 'primary' | 'transparent'

type ArticleOwnProps = Omit<ComponentProps<typeof ArticleRoot>, 'background'> & {
  background: BackgroundVariant
}

export const Article = ({ children, background = 'transparent', ...rest }: ArticleOwnProps) => {
  return (
    <ArticleRoot background={background} {...rest}>
      <ArticleContainer>{children}</ArticleContainer>
    </ArticleRoot>
  )
}

Article.displayName = 'Article'
